import React, {useState} from 'react';
import {Button, Dimmer, Form, Loader, Modal, Segment} from "semantic-ui-react";
import './styles.scss'
import Dropdown from "../components/Dropdown";
import {apiPost} from "../services/apiClient";
import {toast} from "react-toastify";

const StatusChangeModal = ({
    children,
    selectedIds,
    setLoading,
    reload,
    loading,
    clearSelected,
    title = 'Массовая смена статуса посылок',
    emptyListMessage = 'В таблице не могут быть отмечены посылки в различных статусах',
    fetchStatuses,
    applyStatus,
    onSuccess
}) => {
    const [open, setOpen] = useState(false);
    const [status, setStatus] = useState('');
    const [options, setOptions] = useState([]);

    const onClose = () => {
        setOpen(false);
        setStatus('');
        setOptions([]);
    }

    const setExternalLoading = (isLoading) => {
        if (setLoading) {
            setLoading(isLoading);
        }
    }

    const onError = (message) => {
        if (message) {
            toast.error(message);
        } else {
            toast.error(emptyListMessage);
        }
        onClose();
    }

    const onOpen = () => {
        const request = fetchStatuses
            ? fetchStatuses(selectedIds)
            : apiPost('parcels/list/nextstatus/common', {ids: selectedIds});

        request.then(d => {
            if (d && d.entries && d.entries.length) {
                setOpen(true)
                setOptions(d.entries.map(e => ({
                    key: e.id,
                    value: e.id,
                    text: e.name,
                    code: e.code,
                    isDefault: e.isDefault
                })))
            } else {
                onError(d && d.message);
            }
        }).catch(e => {
            console.log(e)
            onError(e && e.message)
        })
    }

    const onSave = () => {
        setExternalLoading(true)

        const request = applyStatus
            ? applyStatus(status, selectedIds)
            : apiPost('parcels/list/nextstatus/apply', {
                ids: selectedIds,
                nextStatus: status
            });

        request.then((data) => {
            if (data && data.warningMessages) {
                toast.warning(data.warningMessages, {autoClose: 30000});
            }
            setExternalLoading(false)
            const selectedOption = options.find(o => o.value === status);

            if (onSuccess) {
                onSuccess(data, selectedOption, status);
                onClose();
                return;
            }

            onClose();
            // Перезагружаем данные и сбрасываем чекбоксы после перезагрузки
            if (reload && clearSelected) {
                reload(() => {
                    clearSelected();
                });
            } else {
                reload && reload();
                clearSelected && clearSelected();
            }
        }).catch((err) => {
            setExternalLoading(false);
            onClose();
            if (err.totalError) {
                let resultMessage = 'Не соблюдены условия для смены статуса посылки:';
                resultMessage += '\n' + err.totalError;
                toast.error(resultMessage)
            } else toast.error('Произошла ошибка')
        })
    }

    return (
        <Modal
            trigger={children}
            closeIcon
            onClose={onClose}
            onOpen={onOpen}
            open={open}
            size="tiny"
        >
            <Modal.Header>
                {title}
            </Modal.Header>

            <Segment vertical style={{borderBottom: 'none'}}>
                <Dimmer active={loading} inverted>
                    <Loader size='medium'/>
                </Dimmer>
                <Modal.Content className='modal__content'>
                    <Form>
                        <Form.Field>
                            <label>
                                Выберите новый статус
                            </label>
                            <Dropdown
                                value={status}
                                options={options}
                                name='status'
                                onChange={(e, {value}) => setStatus(value)}
                            />
                        </Form.Field>
                    </Form>
                </Modal.Content>
            </Segment>

            <Modal.Actions>
                <Button disabled={!status} onClick={onSave} className='modal__actions_yes'>
                    Применить
                </Button>
            </Modal.Actions>
        </Modal>
    );
};

export default StatusChangeModal;


// WEBPACK FOOTER //
// ./App/grids/statusChangeModal.jsx